import { Timestamp } from '@bufbuild/protobuf';
import { useQuery } from '@tanstack/react-query';
import { PROGRAM_SUMMARY_KEY } from '../../../components/delivery/widgets/useProgramFinancialSummary';
import { deliveryClient } from '../../../lib/connect/clients';
import { makeEntityHooks } from '../_shared/hooks/makeEntityHooks';
// PeriodOfPerformance — Upsert/List/Delete
export const popHooks = makeEntityHooks({
    key: 'period of performance',
    list: async (req)=>{
        const resp = await deliveryClient.listPeriodsOfPerformance(req);
        return {
            items: resp.periods
        };
    },
    upsert: async (req)=>{
        const resp = await deliveryClient.upsertPeriodOfPerformance({
            ...req,
            startDate: req.startDate ? Timestamp.fromDate(req.startDate) : undefined,
            endDate: req.endDate ? Timestamp.fromDate(req.endDate) : undefined
        });
        return resp.period;
    },
    remove: async (id)=>{
        await deliveryClient.deletePeriodOfPerformance({
            id
        });
    },
    entityId: (p)=>p.id,
    // PoP funding/totals feed the program TCV + funding rollup (FundingBar, KpiSpine).
    extraInvalidateKeys: [
        PROGRAM_SUMMARY_KEY
    ]
});
// OptionalTask — Upsert/List/Delete
export const optionalTaskHooks = makeEntityHooks({
    key: 'optional task',
    list: async (req)=>{
        const resp = await deliveryClient.listOptionalTasks(req);
        return {
            items: resp.tasks
        };
    },
    upsert: async (req)=>{
        const resp = await deliveryClient.upsertOptionalTask(req);
        return resp.task;
    },
    remove: async (id)=>{
        await deliveryClient.deleteOptionalTask({
            id
        });
    },
    entityId: (t)=>t.id,
    // Optional-task funding/totals feed the program TCV + funding rollup.
    extraInvalidateKeys: [
        PROGRAM_SUMMARY_KEY
    ]
});
// All optional-task exercises for a program in one call (optional_task_id
// empty -> every exercise for the program, per ryugu.proto) — feeds the
// derived Exercised/Completed/Not-exercised tabs on OptionalTasksTab (SAD-341).
// A distinct key from OptionalTaskExercisesDrawer's per-task
// [EXERCISES_KEY, task.id] query, so both must be invalidated together
// whenever an exercise is recorded or deleted.
export const ALL_OPTIONAL_TASK_EXERCISES_KEY = 'optional task exercises (program)';
export function useOptionalTaskExercisesForProgram(programId) {
    return useQuery({
        queryKey: [
            ALL_OPTIONAL_TASK_EXERCISES_KEY,
            programId
        ],
        queryFn: async ()=>{
            const resp = await deliveryClient.listOptionalTaskExercises({
                programId,
                optionalTaskId: ''
            });
            return resp.exercises;
        }
    });
}
